import { ShieldCheck, Award, Microscope, Stethoscope } from "lucide-react";
import { trustSignals } from "@/data";
import { Container } from "@/components/atoms";

const icons = [Stethoscope, Microscope, Award, ShieldCheck];

// Trust Strip — 4 credentials (homepage section #2, frame 20:3).
export function TrustStrip() {
  return (
    <div className="border-y border-night-blue/10 bg-medical-grey">
      <Container className="grid grid-cols-2 gap-4 py-4 md:grid-cols-4">
        {trustSignals.map((signal, i) => {
          const Icon = icons[i % icons.length];
          return (
            <div
              key={signal}
              className="flex items-center justify-center gap-2 text-center"
            >
              <Icon size={20} className="shrink-0 text-leaf-green-ink" />
              <span className="font-condensed text-xs font-bold uppercase tracking-wide text-night-blue/80">
                {signal}
              </span>
            </div>
          );
        })}
      </Container>
    </div>
  );
}
